export default __webpack_public_path__ + "static/sc_o-4a8eeae117dc3d67895fbdf25e9aa3cb.png";